export const MAX_FILE_SIZE = 52428800; //50mb
export const MIN_FILE_SIZE = 1;
